import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const LightbulbIcon = createIcon({
  displayName: 'KeyIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path d="M24 24h-24v-24h24Z"></path>
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M13.674 14.923h-3.348"
        ></path>
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M10.168 14.769l-6.4267e-08-4.53233e-08c-1.4339-1.01123-1.77653-2.9934-.765299-4.4273 1.01123-1.4339 2.9934-1.77653 4.4273-.765299 1.4339 1.01123 1.77653 2.9934.765299 4.4273 -.20945.296994-.468305.555849-.765299.765299l2.52736e-08-1.68605e-08c-.148156.098837-.238549.263936-.242.442v1.465 -1.49476e-08c0 .731225-.592775 1.324-1.324 1.324h-.53l-5.78739e-08-3.55271e-15c-.731225-3.19629e-08-1.324-.592775-1.324-1.324 0 0 0 0 0 0v-1.462l-4.7505e-09-3.44172e-07c-.00247256-.179132-.0929812-.345563-.242-.445Z"
        ></path>
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M5.5 12h.5"
        ></path>
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 5.5v.5"
        ></path>
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M7.4 7.4l.36.36"
        ></path>
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M18 12h.5"
        ></path>
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M16.24 7.76l.36-.36"
        ></path>
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M8 21h8l-2.18557e-07-7.10543e-15c2.76142 1.20706e-07 5-2.23858 5-5v-8 0c0-2.76142-2.23858-5-5-5h-8l-2.18557e-07 5.32907e-15c-2.76142 1.20706e-07-5 2.23858-5 5 0 0 0 1.77636e-15 0 1.77636e-15v8l5.15143e-14 5.36422e-07c4.16963e-07 2.76142 2.23858 5 5 5Z"
        ></path>
      </g>
    </>
  ),
})

const Key: FC<IconProps> = (props) => {
  return <CustomIcon as={LightbulbIcon} {...props} />
}

export default memo(Key)
